import Link from 'next/link'
import clsx from 'clsx'

interface ButtonProps {
  href?: string;
  textSize?: string;
  paddingY?: string;
  [key: string]: string | number | boolean | undefined;
}

export function PrimaryButton({
  href,
  textSize = 'text-lg',
  paddingY = 'py-2',
  ...props
}: ButtonProps) {
  const className = clsx(
    'rounded-full font-semibold  focus:outline-none focus-visible:outline-2 focus-visible:outline-offset-2 px-4 text-white',
    textSize,
    paddingY,
    'bg-sky-500 hover:bg-sky-400'
  )

  return href ? (
    <Link href={href} className={className} {...props} />
  ) : (
    <button className={className} {...props} />
  )
}

export function SecondaryButton({ href, textSize = 'text-lg', ...props }: ButtonProps) {
  const className = clsx(
    'rounded-full bg-gray-300 py-2 px-4 font-semibold text-slate-900 hover:bg-gray-200 focus:outline-none focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-gray-300/50 active:bg-gray-500',
    textSize
  )

  return href ? (
    <Link href={href} className={className} {...props} />
  ) : (
    <button className={className} {...props} />
  )
}
